export default __webpack_public_path__ + "static/media/BR.d4d9416a.svg";